import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-header" }
const _hoisted_2 = { class: "modal-body" }
const _hoisted_3 = { class: "section-group" }
const _hoisted_4 = { class: "section-header-row" }
const _hoisted_5 = {
  key: 0,
  class: "limit-warning"
}
const _hoisted_6 = { class: "ordered-list" }
const _hoisted_7 = { class: "item-info" }
const _hoisted_8 = { class: "item-label" }
const _hoisted_9 = {
  key: 0,
  class: "badge-cross"
}
const _hoisted_10 = {
  key: 1,
  class: "badge-mandatory"
}
const _hoisted_11 = {
  key: 2,
  class: "badge-cross"
}
const _hoisted_12 = {
  key: 3,
  class: "badge-mandatory"
}
const _hoisted_13 = { class: "item-actions" }
const _hoisted_14 = ["onClick", "disabled"]
const _hoisted_15 = ["onClick", "disabled"]
const _hoisted_16 = ["onClick", "disabled"]
const _hoisted_17 = { class: "section-group" }
const _hoisted_18 = { class: "add-selectors" }
const _hoisted_19 = { class: "select-wrapper" }
const _hoisted_20 = ["value"]
const _hoisted_21 = ["disabled"]
const _hoisted_22 = { class: "select-wrapper" }
const _hoisted_23 = ["value"]
const _hoisted_24 = ["disabled"]
const _hoisted_25 = { class: "modal-footer" }

import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
import { useChartVisibility } from '@/composables/useChartVisibility';
import { SENSOR_LABELS, SENSOR_LIST, CROSS_LIST, MANDATORY_CHARTS, MAX_CHARTS_LIMIT } from '@/config/chartConfig';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faArrowUp, faArrowDown, faTrash, faPlus } from '@fortawesome/free-solid-svg-icons';

// blocca scroll del body quando il modale è aperto

export default /*@__PURE__*/_defineComponent({
  __name: 'ChartVisibilityModal',
  props: {
    deviceType: {}
  },
  emits: ["close", "saved"],
  setup(__props: any, { emit: __emit }) {

onMounted(() => {
  document.body.style.overflow = 'hidden';
});

onBeforeUnmount(() => {
  document.body.style.overflow = '';
});

const props = __props;

const emit = __emit;

const { preferences, resetToDefaults: resetPrefs } = useChartVisibility();

// Copia locale per permettere annullamento
const localOrderedCharts = ref<string[]>([...preferences.value.orderedCharts]);
const selectedSensorToAdd = ref("");
const selectedCrossToAdd = ref("");

onMounted(() => {
  localOrderedCharts.value = [...preferences.value.orderedCharts];
});

const isMandatory = (id: string) => MANDATORY_CHARTS.includes(id);
const isCross = (id: string) => CROSS_LIST.some(c => c.id === id);
const isLimitReached = computed(() => localOrderedCharts.value.length >= MAX_CHARTS_LIMIT);

const getLabel = (id: string) => {
  const cross = CROSS_LIST.find(c => c.id === id);
  if (cross) return cross.title;
  return SENSOR_LABELS[id] || id;
};

const availableSensors = computed(() => {
  return SENSOR_LIST.filter(s => !localOrderedCharts.value.includes(s));
});

const availableCross = computed(() => {
  return CROSS_LIST.filter(c => !localOrderedCharts.value.includes(c.id));
});

const add = (id: string) => {
  if (!id || isLimitReached.value) return;
  if (!localOrderedCharts.value.includes(id)) {
    localOrderedCharts.value.push(id);
  }
  selectedSensorToAdd.value = "";
  selectedCrossToAdd.value = "";
};

const remove = (id: string) => {
  if (isMandatory(id)) return;
  localOrderedCharts.value = localOrderedCharts.value.filter(item => item !== id);
};

const move = (index: number, direction: 'up' | 'down') => {
  const newIndex = direction === 'up' ? index - 1 : index + 1;
  if (newIndex < 0 || newIndex >= localOrderedCharts.value.length) return;
  
  const list = [...localOrderedCharts.value];
  const temp = list[index];
  list[index] = list[newIndex];
  list[newIndex] = temp;
  localOrderedCharts.value = list;
};

const save = () => {
  preferences.value.orderedCharts = [...localOrderedCharts.value];
  emit('saved');
  emit('close');
};

const resetToDefaults = () => {
  // Ripristiniamo i default nel composable e poi nella copia locale
  resetPrefs();
  localOrderedCharts.value = [...preferences.value.orderedCharts];
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      class: "modal-overlay",
      onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["self"]))
    }, [
      _createElementVNode("div", {
        class: "modal-container",
        onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["stop"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _cache[8] || (_cache[8] = _createElementVNode("h2", null, "Configura Grafici", -1)),
          _createElementVNode("button", {
            class: "btn-close",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close'))),
            title: "Chiudi"
          }, "×")
        ]),
        _createElementVNode("div", _hoisted_2, [
          _cache[15] || (_cache[15] = _createElementVNode("p", { class: "modal-description" }, " Aggiungi, rimuovi e ordina i grafici da visualizzare nella pagina Data. I grafici evidenziati sono obbligatori. ", -1)),
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _cache[9] || (_cache[9] = _createElementVNode("h3", { class: "section-title" }, "Grafici Selezionati (Ordine di visualizzazione)", -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["count-badge", { 'warning': isLimitReached.value }])
              }, _toDisplayString(localOrderedCharts.value.length) + " / " + _toDisplayString(_unref(MAX_CHARTS_LIMIT)), 3)
            ]),
            (isLimitReached.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, " ⚠️ Hai raggiunto il limite massimo di grafici. Rimuovi un grafico per aggiungerne un altro. "))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(localOrderedCharts.value, (id, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: id,
                  class: _normalizeClass(["order-item", { 'mandatory': isMandatory(id) }])
                }, [
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(getLabel(id)), 1),
                    (isMandatory(id) && isCross(id))
                      ? (_openBlock(), _createElementBlock("span", _hoisted_9, "Combined Default Setting"))
                      : (isMandatory(id))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Single Default Setting"))
                        : (isCross(id))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "Combined"))
                          : (_openBlock(), _createElementBlock("span", _hoisted_12, "Single"))
                  ]),
                  _createElementVNode("div", _hoisted_13, [
                    _createElementVNode("button", {
                      class: "btn-icon",
                      onClick: ($event: any) => (move(index, 'up')),
                      disabled: index === 0,
                      title: "Sposta su"
                    }, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faArrowUp) }, null, 8, ["icon"])
                    ], 8, _hoisted_14),
                    _createElementVNode("button", {
                      class: "btn-icon",
                      onClick: ($event: any) => (move(index, 'down')),
                      disabled: index === localOrderedCharts.value.length - 1,
                      title: "Sposta giù"
                    }, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faArrowDown) }, null, 8, ["icon"])
                    ], 8, _hoisted_15),
                    _createElementVNode("button", {
                      class: "btn-icon btn-remove",
                      onClick: ($event: any) => (remove(id)),
                      disabled: isMandatory(id),
                      title: "Rimuovi"
                    }, [
                      _createVNode(_unref(FontAwesomeIcon), { icon: _unref(faTrash) }, null, 8, ["icon"])
                    ], 8, _hoisted_16)
                  ])
                ], 2))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_17, [
            _cache[14] || (_cache[14] = _createElementVNode("h3", { class: "section-title" }, "Aggiungi Altri Grafici", -1)),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _cache[11] || (_cache[11] = _createElementVNode("label", null, "Grafici Singoli", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedSensorToAdd).value = $event)),
                  class: "custom-select"
                }, [
                  _cache[10] || (_cache[10] = _createElementVNode("option", { value: "" }, "Seleziona sensore...", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableSensors.value, (s) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: s,
                      value: s
                    }, _toDisplayString(_unref(SENSOR_LABELS)[s] || s), 9, _hoisted_20))
                  }), 128))
                ], 512), [
                  [_vModelSelect, selectedSensorToAdd.value]
                ]),
                _createElementVNode("button", {
                  class: "btn-add",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (add(selectedSensorToAdd.value))),
                  disabled: !selectedSensorToAdd.value || isLimitReached.value
                }, " Aggiungi ", 8, _hoisted_21)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _cache[13] || (_cache[13] = _createElementVNode("label", null, "Grafici Combinati", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((selectedCrossToAdd).value = $event)),
                  class: "custom-select"
                }, [
                  _cache[12] || (_cache[12] = _createElementVNode("option", { value: "" }, "Seleziona combinato...", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableCross.value, (c) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: c.id,
                      value: c.id
                    }, _toDisplayString(c.title), 9, _hoisted_23))
                  }), 128))
                ], 512), [
                  [_vModelSelect, selectedCrossToAdd.value]
                ]),
                _createElementVNode("button", {
                  class: "btn-add",
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (add(selectedCrossToAdd.value))),
                  disabled: !selectedCrossToAdd.value || isLimitReached.value
                }, " Aggiungi ", 8, _hoisted_24)
              ])
            ])
          ]),
          _createElementVNode("div", { class: "quick-actions" }, [
            _createElementVNode("button", {
              class: "btn-secondary",
              onClick: resetToDefaults
            }, " Ripristina Default ")
          ])
        ]),
        _createElementVNode("div", _hoisted_25, [
          _createElementVNode("button", {
            class: "btn-cancel",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('close')))
          }, "Annulla"),
          _createElementVNode("button", {
            class: "btn-save",
            onClick: save
          }, "Salva")
        ])
      ])
    ])
  ]))
}
}

})